import api from '../api/axios';
import store from '../stores/store';
import { localLoginUser } from '@/stores/auth/services';
import { startCheckConsent } from './consents';
import { Platform } from 'react-native';

export const writeToEpa = async () => {
  await api.post('/api/patients/practicesessions/results/export/epa');
};

export const loginWithEpa = async (context: any, onError: () => void) => {
  const auth = async (authToken: string) => {
    const loginResponse = await loginWithIdpToken(authToken);
    if (
      loginResponse.error &&
      loginResponse.code === 'error.idp.noUserWithInsuranceIdFound'
    ) {
      onError();
    }
  };

  const { startAuth } = context;
  await startAuth(auth);
};

export const connectWithEpa = async (
  context: any,
  onSuccess: (insuranceId: string) => void,
  onError: () => void,
) => {
  try {
    const connect = async (authToken: string) => {
      try {
        const insuranceId = await connectWithIdp(authToken);
        onSuccess(insuranceId);
      } catch {
        onError();
      }
    };

    const { startAuth } = context;
    await startAuth(connect);
  } catch {
    onError();
  }
};

const connectWithIdp = async (token: string) => {
  try {
    const response = await api.post(
      `/api/auth/idp/connect-with-epa`,
      {
        token,
      },
      {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      },
    );
    return await response.data.idpInsuranceId;
  } catch {
    throw new Error('error.idp.idpConnectionFailed');
  }
};

const loginWithIdpToken = async (token: string) => {
  try {
    let deviceModel =
      Platform.OS === 'ios' ? 'ios-device' : (Platform.constants as any)?.Model;
    if (!deviceModel) {
      deviceModel = 'android-device';
    }
    const loginData = {
      app: Platform.OS === 'web' ? 'browser' : Platform.OS,
      deviceModel,
    };

    const response = await api.post(
      `/api/auth/idp/login-with-idp`,
      {
        token,
        ...loginData,
      },
      {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      },
    );

    if (!response.data.accessToken) {
      return {
        error: 'error.idp.noAccessTokenCreated',
      };
    }

    await localLoginUser({
      accessToken: response.data.accessToken,
      user: {
        _id: response.data.user._id,
        email: response.data.user.email,
        code: response.data.user.code,
        firstName: response.data.user.firstName,
        lastName: response.data.user.lastName,
        therapistCanSeeResults: response.data.user.therapistCanSeeResults,
        idpInsuranceId: response.data.user.idpInsuranceId,
        userEpa: response.data.user.userEpa,
        appLockPattern: response.data.user.appLockPattern,
        appStartResumeLock: response.data.user.appStartResumeLock,
        eigentrainingLock: response.data.user.eigentrainingLock,
      },
    });
    store
      .getActions()
      .initializeResultsWithKeyAndPracticeSessionWithKey(undefined);

    startCheckConsent();

    return {
      accessToken: response.data.accessToken,
    };
  } catch (e: any) {
    if (e.response?.data) {
      return e.response.data;
    }
  }
};
